import React, { FC, useRef } from 'react';
import { time } from 'uniqid';
import { Entry } from '../Entry';
import { Error } from '../Error';

export type MultiEntryProps = {
  id?: string;
  name: string;
  type?: string;
  ariaLabel: string;
  buttonAriaLabel?: string;
  className?: string;
  error?: string;
  values: string[];
  entryMask?: string;
  onChange: (value: string, index: number) => void;
  onAdd: () => void;
  children?: React.ReactNode;
};

export const MultiEntry: FC<MultiEntryProps> = ({
  error,
  name,
  onChange,
  onAdd,
  values,
  entryMask,
  id = time('multi-entry-id-'),
  type = 'tel',
  buttonAriaLabel = 'add',
  className = '',
  children,
  ariaLabel
}) => {
  const inputRef = useRef<HTMLInputElement>();
  return (
    <div id={id} data-testid={id} className={className}>
      <label className="mb-0">{children}</label>
      <div className="d-flex flex-wrap multi-entries">
        {values &&
          values.map((value, index) => (
            <Entry
              id={`${id}-${index}`}
              data-testid={`${id}-${index}`}
              key={`multi-entry-${index}`}
              name={`${name}[${index}]`}
              aria-label={`${ariaLabel} ${index + 1}`}
              type={type}
              onChange={e => onChange(e.currentTarget.value, index)}
              ref={inputRef}
              value={value}
              className={`${error ? 'error' : ''}`}
              mask={entryMask}
            />
          ))}
        <button
          id={`${id}-button`}
          data-testid={`${id}-button`}
          onClick={e => {
            e.preventDefault();
            onAdd();
            setTimeout(() => inputRef.current && inputRef.current.focus(), 0);
          }}
          aria-label={buttonAriaLabel}
          className="dis-brd">
          <span aria-hidden="true" className="add-icon" />
        </button>
      </div>
      <Error errors={error} />
    </div>
  );
};

export default MultiEntry;
